import * as React from 'react';
import { MediaQuery, Carousel } from '@grandvisionhq/common';

const ProductBlockCarousel = ({ skus , renderProductBlock  })=>{
    const [activeIndex, setActiveIndex] = React.useState(0);
    const itemsPerSlide = MediaQuery.useIsDesktop() ? 4 : 3;
    const carouselSlides = React.useMemo(()=>{
        const amountOfSlides = Math.ceil(skus.length / itemsPerSlide);
        return Array.from({
            length: amountOfSlides
        }, (_, i)=>{
            const start = i * itemsPerSlide;
            const end = (i + 1) * itemsPerSlide;
            const slideSkus = skus.slice(start, end);
            const slideKey = slideSkus.toString();
            return /*#__PURE__*/ React.createElement("div", {
                key: slideKey,
                className: "product-block-carousel__slide"
            }, slideSkus.map((sku)=>{
                const tabIndex = activeIndex !== i ? -1 : undefined;
                return renderProductBlock({
                    sku,
                    tabIndex
                });
            }));
        });
    }, [
        skus,
        itemsPerSlide,
        activeIndex,
        renderProductBlock
    ]);
    return /*#__PURE__*/ React.createElement(Carousel, {
        className: "product-block-carousel",
        pagination: false,
        navigation: true,
        loopNavigationFocus: true,
        onIndexChange: setActiveIndex
    }, carouselSlides);
};

export { ProductBlockCarousel };
//# sourceMappingURL=ProductBlockCarousel.js.map
